import Form from './QuoteForm'
import isEmpty from './QuoteIsEmpty'
import Section from './QuoteSection'
import Thumbnail from './QuoteThumbnail'

export default { Form, isEmpty, Section, Thumbnail }
